import Vue from 'vue'
import App from './App.vue'
import router from '@/router'
import store from './store/'
import './permission' // permission control
import Antd, { Carousel,Collapse } from 'ant-design-vue'
import 'ant-design-vue/dist/antd.css'

// 引入moment并设置中文语言
import moment from 'moment'
import 'moment/locale/zh-cn'

// 设置moment为中文
moment.locale('zh-cn')

Vue.use(Antd)
Vue.use(Carousel)
Vue.use(Collapse)

Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
